export { default } from './Hero';



// WEBPACK FOOTER //
// ./src/components/PageHeader/Hero/index.js